import { countBy } from "es-toolkit/array"
import { keys, values } from "es-toolkit/compat"

export function mode(array: number[]): number {
  const counts = countBy(array, x => x)
  const maxCount = Math.max(...values(counts))
  const [mostCommon] = keys(counts).filter(
    key => counts[Number(key)] === maxCount,
  )

  return Number.parseFloat(mostCommon)
}
